const randomBetween = ({ min, max }) => min + Math.random() * (max - min);

export default function createCrossBehavior(config) {
  const cross = config.cross;
  const duration = randomBetween(cross.duration);
  const direction = Math.random() < 0.5 ? 1 : -1;
  const top = randomBetween(cross.top) / 100;
  const bobPhase = Math.random() * Math.PI * 2;
  const margin = config.size + 30;
  const result = {
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    finished: false,
  };

  return {
    duration,
    update(elapsed, _delta, viewport) {
      const progress = Math.min(elapsed / duration, 1);
      const start = direction === 1
        ? -viewport.width / 2 - margin
        : viewport.width / 2 + margin;
      const end = direction === 1
        ? viewport.width / 2 + margin
        : -viewport.width / 2 - margin;
      const bob = cross.bob.amplitude * Math.sin(bobPhase + elapsed * cross.bob.frequency * Math.PI * 2);

      result.position.x = start + (end - start) * progress;
      result.position.y = viewport.height / 2 - top * viewport.height + bob;
      result.position.z = 0;
      result.rotation.y = cross.facing === "travel" ? direction * Math.PI / 2 : 0;
      result.finished = progress >= 1;
      return result;
    },
  };
}
